// Ported from the Polaris kit: src/components/ui/item/index.js.
// Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
// Change the design in the kit first, then re-port.
import { cva } from 'class-variance-authority';

export { default as Item } from './Item.vue';
export { default as ItemActions } from './ItemActions.vue';
export { default as ItemContent } from './ItemContent.vue';
export { default as ItemDescription } from './ItemDescription.vue';
export { default as ItemFooter } from './ItemFooter.vue';
export { default as ItemGroup } from './ItemGroup.vue';
export { default as ItemHeader } from './ItemHeader.vue';
export { default as ItemMedia } from './ItemMedia.vue';
export { default as ItemSeparator } from './ItemSeparator.vue';
export { default as ItemTitle } from './ItemTitle.vue';

export const itemVariants = cva(
  'group/item flex items-center border border-solid border-transparent type-polaris-body rounded-polaris-md transition-colors [&:is(a)]:hover:bg-polaris-accent/50 [&:is(a)]:transition-colors duration-100 flex-wrap outline-none focus-visible:border-polaris-ring focus-visible:ring-polaris-ring/50 focus-visible:ring-[3px]',
  {
    variants: {
      variant: {
        default: 'bg-transparent',
        outline: 'border-polaris-border',
        muted: 'bg-polaris-muted/50',
      },
      size: {
        default: 'p-4 gap-4 ',
        sm: 'py-3 px-4 gap-2.5',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

export const itemMediaVariants = cva(
  'flex shrink-0 items-center justify-center gap-2 group-has-[[data-slot=item-description]]/item:self-start [&_svg]:pointer-events-none group-has-[[data-slot=item-description]]/item:translate-y-0.5',
  {
    variants: {
      variant: {
        default: 'bg-transparent',
        icon: "size-8 border border-solid border-polaris-border rounded-polaris-sm bg-polaris-muted [&_svg:not([class*='size-'])]:size-4 p-0",
        image:
          'size-10 rounded-polaris-sm overflow-hidden [&_img]:size-full [&_img]:object-cover p-0',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
